const Schedule = () => import('@pages/specialClinic/Schedule')
const Detail = () => import('@pages/specialClinic/Schedule/Detail')
const Order = () => import('@pages/specialClinic/Schedule/Order')

export const specialClinic = [
  {
    path: '/specialClinic/schedule',
    name: 'SpecialSchedule',
    component: Schedule,
    meta: {}
  },
  {
    path: '/specialClinic/detail/:id',
    name: 'SpecialScheduleDetail',
    component: Detail,
    meta: {}
  },
  {
    path: '/specialClinic/order/:id',
    name: 'SpecialScheduleOrder',
    component: Order,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/specialClinic.route.js